/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FunktionsbereichDetail { 
    titel: string;
    funktionsbereich_id: string;
    explizite_freigabe_erforderlich?: boolean;
    email_benachrichtigungen_bei_bereitschaft_empfaenger?: string;
    hat_email_benachrichtigungen_bei_bereitschaft?: boolean;
    email_benachrichtigungen_bei_fehlerfall_empfaenger?: string;
    hat_email_benachrichtigungen_bei_fehlerfall?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

